import React from "react";
import { formatRangeVal, getExposure, bookClass, bookText, isSuspended, useRangeToggle } from "../../casinoComponents/userSiteLastResult/refUtils";
import { RangeIcon, RefRemark } from "../../casinoComponents/userSiteLastResult/refBits";
import Collapse from "../../../components/Collapse";

const SUIT = `${import.meta.env.BASE_URL}img/cardIcons`;

/**
 * V-20-20 D T L (vdtl20) bet area in the reference markup (inside .casino-detail):
 *   .main-odds > .main-odds-left ("Main Odds": header row + Dragon / Tiger / Lion rows × Winner, Black, Red, Odd, Even)
 *              + .main-odds-right ("Card Odds": Dragon / Tiger / Lion boxes × A … K)
 *   + .casino-remark. Markets = sub sorted by sr: 0-17 Dragon, 18-35 Tiger, 36-53 Lion.
 */
export default function DtlVirtualTable({ raw = {}, exposures = {}, gameType = "vdtl20" }) {
  const [open, toggle] = useRangeToggle();
  const sub = Array.isArray(raw?.sub) ? raw.sub : [];
  const main = sub
    .filter((s) => !s?.subtype || s.subtype === gameType)
    .sort((a, b) => Number(a?.sr) - Number(b?.sr));

  const range = (id, item, indent = "\n                                                R:") => (
    <div className="d-inline-block ml-2 float-right">
      <RangeIcon id={id} open={!!open[id]} onToggle={toggle} />{" "}
      <Collapse id={id} open={!!open[id]} className="icon-range">
        {indent}
        <span>{formatRangeVal(item?.min)}</span>-<span>{formatRangeVal(item?.max)}</span>
      </Collapse>
    </div>
  );

  const item = (m) => {
    const exp = getExposure(exposures, m?.nat);
    const susp = isSuspended(m);
    return (
      <div className={`casino-bl-box-item back${susp ? " suspended lock-top" : ""}`}>
        <span className="casino-box-odd">{m?.b}</span>{" "}
        <span className={`book-odd ${bookClass(exp)}`}>{bookText(exp)}</span>
      </div>
    );
  };

  const imgs = (names) =>
    names.map((n) => (
      <React.Fragment key={n}>
        <img src={`${SUIT}/${n}.png`} alt="" />{" "}
      </React.Fragment>
    ));

  const mainRow = (label, off) => (
    <div className="v-odd-row">
      <div className="v-odd-box">
        <b>{label}</b>
      </div>{" "}
      {[1, 2, 3, 4, 5].map((s) => (
        <div className="v-odd-box" key={s}>
          <div className="casino-bl-box">{item(main[s + off])}</div>
        </div>
      ))}
    </div>
  );

  const cardLabel = (s) => (s === 11 ? "J" : s === 12 ? "Q" : s === 13 ? "K" : String(s));
  const CARDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
  const cardBox = (cls, name, off, nested) => (
    <div className={`w-100 mt-2 ${cls}`}>
      <h5 className="text-center">{name}</h5>{" "}
      <div className="v-odd-row">
        {CARDS.map((s) => {
          const m = main[s + off];
          const id = `demo${s + off}`;
          return (
            <div className="v-odd-box" key={s}>
              <div className="casino-bl-box">
                <div className="w-100-text-center">
                  <b>{cardLabel(s)}</b> {range(id, m, "\n                                                                R:")}
                </div>{" "}
                {/* reference: Dragon's item sits directly in the box, Tiger / Lion wrap it in another .casino-bl-box */}
                {nested ? <div className="casino-bl-box">{item(m)}</div> : item(m)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <>
      <div className="main-odds">
        <div className="main-odds-left">
          <div className="vdtl-odds-heading">Main Odds</div>{" "}
          <div className="v-odd-row">
            <div className="v-odd-box">
              <b>{" "}</b>
            </div>{" "}
            <div className="v-odd-box">
              <b>Winner</b> {range("demo0", main[0])}
            </div>{" "}
            <div className="v-odd-box">
              {imgs(["spade", "club"])}
              {range("demo1", main[1])}
            </div>{" "}
            <div className="v-odd-box">
              {imgs(["heart", "diamond"])}
              {range("demo2", main[2])}
            </div>{" "}
            <div className="v-odd-box">
              <b>Odd</b> {range("demo3", main[3])}
            </div>{" "}
            <div className="v-odd-box">
              <b>Even</b> {range("demo4", main[4])}
            </div>
          </div>{" "}
          {mainRow("Dragon", -1)} {mainRow("Tiger", 17)} {mainRow("Lion", 35)}
        </div>{" "}
        <div className="main-odds-right">
          <div className="vdtl-odds-heading">Card Odds</div>{" "}
          {cardBox("v-dragon-box", "Dragon", 4, false)} {cardBox("v-tiger-box", "Tiger", 22, true)}{" "}
          {cardBox("v-lion-box", "Lion", 40, true)}
        </div>
      </div>{" "}
      <RefRemark remark={raw?.remark} />
    </>
  );
}
